export var headers = {
	"Project-Id-Version": "open-xchange-appsuite-blackwhitelist",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "",
	"PO-Revision-Date": "2024-02-01 09:06+0100",
	"Last-Translator": "Jöran Kuschel",
	Language: "de_DE",
	"Language-Team": "NAME <EMAIL>",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bit",
	"Plural-Forms": "nplurals=2; plural=(n != 1);",
	"MIME-Version": "1.0",
	"X-Generator": "Poedit 3.4.2"
};
export default {
	headers: headers,
	"\u0000Access Lists\u0001": [
	"Zugriffslisten"
],
	"\u0000Add\u0001": [
	"Hinzufügen"
],
	"\u0000Add domain to Allowlist\u0001": [
	"Domain zu Zulassungsliste hinzufügen"
],
	"\u0000Add domain to Blocklist\u0001": [
	"Domain zu Blockierliste hinzufügen"
],
	"\u0000Add new address\u0001": [
	"Neue Adresse hinzufügen"
],
	"\u0000Add new address to Allowlist\u0001": [
	"Neue Adresse zu Zulassungsliste hinzufügen"
],
	"\u0000Add new address to Blocklist\u0001": [
	"Neue Adresse zu Blockierliste hinzufügen"
],
	"\u0000Add sender domain to Allowlist\u0001": [
	"Absenderdomain zu Zulassungsliste hinzufügen"
],
	"\u0000Add sender domain to Blocklist\u0001": [
	"Absenderdomain zu Blockierliste hinzufügen"
],
	"\u0000Add sender to Allowlist\u0001": [
	"Absender zu Zulassungsliste hinzufügen"
],
	"\u0000Add sender to Blocklist\u0001": [
	"Absender zu Blockierliste hinzufügen"
],
	"\u0000Address added correctly\u0001": [
	"Adresse erfolgreich hinzugefügt"
],
	"\u0000Address could not be removed\u0001Addresses could not be removed": [
	"Adresse konnte nicht entfernt werden",
	"Adressen konnten nicht entfernt werden"
],
	"\u0000Address could not be saved\u0001": [
	"Die Adresse konnte nicht gespeichert werden"
],
	"\u0000Address removed correctly\u0001Addresses removed correctly": [
	"Adresse erfolgreich entfernt",
	"Adressen erfolgreich entfernt"
],
	"\u0000Address updated correctly\u0001": [
	"Adresse erfolgreich aktualisiert"
],
	"\u0000Allowed Senders\u0001": [
	"Zulässige Absender"
],
	"\u0000Allowlist\u0001": [
	"Zulassungsliste"
],
	"\u0000Allowlist updated correctly\u0001": [
	"Zulassungsliste erfolgreich aktualisiert"
],
	"\u0000Blocked Senders\u0001": [
	"Blockierte Absender"
],
	"\u0000Blocklist\u0001": [
	"Blockierliste"
],
	"\u0000Blocklist updated correctly\u0001": [
	"Blockierliste erfolgreich aktualisiert"
],
	"\u0000Define who is allowed or blocked to send email to you\u0001": [
	"Legen Sie fest, wer für den E-Mail-Versand an Sie zugelassen oder blockiert wird"
],
	"\u0000Define who is allowed to send email to you\u0001": [
	"Legen Sie fest, wer für den E-Mail-Versand an Sie zugelassen wird"
],
	"\u0000Define who is blocked to send email to you\u0001": [
	"Legen Sie fest, wer für den E-Mail-Versand an Sie blockiert wird"
],
	"\u0000Do you really want to remove address: %1$s?\u0001": [
	"Möchten Sie die Adresse wirklich entfernen: %1$s?"
],
	"\u0000Do you really want to remove item ?\u0001Do you really want to remove %1$s items ?": [
	"Möchten Sie das Element wirklich entfernen?",
	"Möchten Sie die %1$s Elemente wirklich entfernen?"
],
	"\u0000Edit\u0001": [
	"Bearbeiten"
],
	"\u0000Edit address in Allowlist\u0001": [
	"Adresse in Zulassungsliste bearbeiten"
],
	"\u0000Edit address in Blocklist\u0001": [
	"Adresse in Blockierliste bearbeiten"
],
	"\u0000Email address\u0001": [
	"E-Mail-Adresse"
],
	"\u0000Filter\u0001": [
	"Filtern"
],
	"\u0000Invalid sender addresses were ignored.\u0001": [
	"Ungültige Absenderadressen wurden ignoriert."
],
	"\u0000No addresses yet\u0001": [
	"Noch keine Adressen auf dieser Liste"
],
	"\u0000Please confirm that you want to add to Allowlist the following domain:\u0001Please confirm that you want to add to Allowlist the following domains:": [
	"Bitte bestätigen Sie, dass Sie die folgende Domain in die Zulassungsliste aufnehmen möchten:",
	"Bitte bestätigen Sie, dass Sie die folgenden Domains in die Zulassungsliste aufnehmen möchten:"
],
	"\u0000Please confirm that you want to add to Allowlist the following email address:\u0001Please confirm that you want to add to Allowlist the following email addresses:": [
	"Bitte bestätigen Sie, dass Sie die folgende E-Mail-Adresse in die Zulassungsliste aufnehmen möchten:",
	"Bitte bestätigen Sie, dass Sie die folgenden E-Mail-Adressen in die Zulassungsliste aufnehmen möchten:"
],
	"\u0000Please confirm that you want to add to Blocklist the following domain:\u0001Please confirm that you want to add to Blocklist the following domains:": [
	"Bitte bestätigen Sie, dass Sie die folgende Domain in die Blockierliste aufnehmen möchten:",
	"Bitte bestätigen Sie, dass Sie die folgenden Domains in die Blockierliste aufnehmen möchten:"
],
	"\u0000Please confirm that you want to add to Blocklist the following email address:\u0001Please confirm that you want to add to Blocklist the following email addresses:": [
	"Bitte bestätigen Sie, dass Sie die folgende E-Mail-Adresse in die Blockierliste aufnehmen möchten:",
	"Bitte bestätigen Sie, dass Sie die folgenden E-Mail-Adressen in die Blockierliste aufnehmen möchten:"
],
	"\u0000Please enter a valid email address\u0001": [
	"Bitte geben Sie eine gültige E-Mail-Adresse ein"
],
	"\u0000Please enter a valid email address or a valid domain starting with @\u0001": [
	"Bitte geben Sie eine gültige E-Mailadresse ein oder eine gültige Domain beginnend mit @."
],
	"\u0000Remove\u0001": [
	"Entfernen"
],
	"\u0000Remove address from Allowlist\u0001": [
	"Adresse aus Zulassungsliste entfernen"
],
	"\u0000Remove address from Blocklist\u0001": [
	"Adresse aus Blockierliste entfernen"
],
	"\u0000Remove selected\u0001": [
	"Auswahl entfernen"
],
	"\u0000Remove selected from Allowlist\u0001": [
	"Auswahl aus Zulassungsliste entfernen"
],
	"\u0000Remove selected from Blocklist\u0001": [
	"Auswahl aus Blockierliste entfernen"
],
	"\u0000Save\u0001": [
	"Speichern"
],
	"\u0000Select all\u0001": [
	"Alle auswählen"
],
	"\u0000The address you are trying to add is already on your %s.\u0001The addresses you are trying to add are already on your %s.": [
	"Die Adresse, die Sie hinzufügen möchten, befindet sich schon auf Ihrer %s.",
	"Die Adressen, die Sie hinzufügen möchten, befinden sich schon auf Ihrer %s."
],
	"\u0000The domain will be added to your Allowlist and from now on you will receive emails from senders with this domain in your inbox bypassing the spam handler.\u0001The domains will be added to your Allowlist and from now on you will receive emails from senders  with those domains in your inbox bypassing the spam handler.": [
	"Die Domain wird zu Ihrer Zulassungsliste hinzugefügt. Von nun an erhalten Sie E-Mails von Absendern mit dieser Domain in Ihrem Posteingang unter Umgehung des Spam-Handlers.",
	"Die Domains werden zu Ihrer Zulassungsliste hinzugefügt. Von nun an erhalten Sie E-Mails von Absendern mit dieser Domain in Ihrem Posteingang unter Umgehung des Spam-Handlers."
],
	"\u0000The sender domain will be added to your Blocklist and from now on you will no longer receive emails from senders with this domain in your inbox\u0001The senders domains will be added to your Blocklist and from now on you will no longer receive emails from senders with those domains in your inbox": [
	"Die Absenderdomain wird zu Ihrer Blockierliste hinzugefügt. Sie erhalten von nun an keine E-Mails von Absendern mit dieser Domain mehr in Ihrem Posteingang.",
	"Die Absenderdomains werden zu Ihrer Blockierliste hinzugefügt. Sie erhalten von nun an keine E-Mails von Absendern mit dieser Domain mehr in Ihrem Posteingang."
],
	"\u0000The sender will be added to your Allowlist and from now on you will receive emails from this sender in your inbox bypassing the spam handler.\u0001The senders will be added to your Allowlist and from now on you will receive emails from these senders in your inbox bypassing the spam handler.": [
	"Der Absender wird zu Ihrer Zulassungsliste hinzugefügt. Von nun an erhalten Sie E-Mails von diesem Absender in Ihrem Posteingang unter Umgehung des Spam-Handlers.",
	"Die Absender werden zu Ihrer Zulassungsliste hinzugefügt. Von nun an erhalten Sie E-Mails von diesen Absendern in Ihrem Posteingang unter Umgehung des Spam-Handlers."
],
	"\u0000The sender will be added to your Blocklist and from now on you will no longer receive emails from this sender in your inbox\u0001The senders will be added to your Blocklist and from now on you will no longer receive emails from these senders in your inbox": [
	"Der Absender wird zu Ihrer Blockierliste hinzugefügt. Von nun an erhalten Sie keine E-Mails mehr von diesem Absender in Ihrem Posteingang",
	"Die Absender werden zu Ihrer Blockierliste hinzugefügt und von nun an erhalten Sie keine E-Mails mehr von diesen Absendern in Ihrem Posteingang"
],
	"\u0000You can not add yourself to the %s.\u0001": [
	"Sie können sich nicht selbst zur %s hinzufügen."
],
	"\u0000You cannot add items to your %s that are already on your %s\u0001": [
	"Sie können keine Adressen zur %s hinzufügen, die bereits auf Ihrer %s stehen"
],
	"\u0000You exceeded the maximum number of items on your %s. Please delete some addresses first.\u0001": [
	"Sie haben die maximale Anzahl an Adressen auf der %s erreicht. Bitte löschen Sie zunächst Einträge."
],
	"\u0000edit\u0001": [
	"bearbeiten"
],
	"\u0000remove\u0001": [
	"entfernen"
]
};
